<template>
    <div>
        <v-layout wrap align-center justify-center class="px-2">
            <v-flex xs12 mt-1>
                <v-layout row wrap >
                    <v-flex my-2 :class="pricingTypeItem.value == DEFINES.PREMIUM_SCREENING_PRICING_TYPE.NORMAL ? 'pr-2' : 'pl-2'" xs12 md6 v-for="(pricingTypeItem,index) in pricingTypes" :key="index">
                        <v-card class="mx-auto" height="100%">
                            <v-card-text>
                                <div class="headline text-xs-center font-weight-black">{{pricingTypeItem.label}}</div>
                                <v-divider class="my-3"></v-divider>
                                <div>
                                   <div class="text-xs-center">
                                        <div>{{$t('starts_at.title')}}</div>
                                        <div class="display-2">{{pricingTypeItem.price}}</div>
                                        <div class="py-3">
                                            <v-btn large block color="primary" :disabled="pricingTypeItem.disabled" @click.stop="pricingTypeItem.action(pricingTypeItem.value)">{{$t('select.title')}}</v-btn>
                                        </div>
                                   </div>
                                    <ul class="pl-3 subheading" style="line-height: 1.7em">
                                        <li class="error--text" v-if="isReducedPriceAvailable && pricingTypeItem.value == DEFINES.PREMIUM_SCREENING_PRICING_TYPE.REDUCED">{{$t('screener.billing.pricing.reduced.instruction_1')}}&nbsp;<span @click="redirectTo()" class="cursor-pointer"><b><u>{{$t('rms.click_here')}}</u></b></span>&nbsp;{{$t('screener.billing.pricing.reduced.instruction_2')}}</li>
                                        <li v-for="(feature, key) in pricingTypeItem.features" :key="key" v-html="feature.title"></li>
                                    </ul>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-flex xs12>
                    <div class="mt-4 subheading"><b class="red--text">{{$t('screener.note.title')}} :- </b><span class="greyDarken3--text">{{$t('screener.billing.pricing.reduced.plan_update_note')}}</span></div>
                </v-flex>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
export default {
    name:"BillingPricingTypeSelection",
    props:{
        isReducedPriceAvailable:{
            default: false,
        }
    },
    data(){
        return{
            alert: true,
            pricingType:this.DEFINES.PREMIUM_SCREENING_PRICING_TYPE.NORMAL,
            pricingTypes:[
                {
                    label:this.$t('screener.billing.pricing.normal.title'),
                    value:this.DEFINES.PREMIUM_SCREENING_PRICING_TYPE.NORMAL,
                    action:this.setPricingType,
                    disabled:false,
                    icon: "mdi-desktop-mac",
                    price:'€50',
                    features:[
                        {title:this.$t('screener.billing.pricing.normal.feature_1',{
                            revenue_percentage:'100%'
                        })},
                        {title:this.$t('screener.billing.pricing.normal.feature_2')},
                        {title:this.$t('screener.billing.pricing.normal.feature_3')}
                    ]
                },
                {
                    label:this.$t('screener.billing.pricing.reduced.title'),
                    value:this.DEFINES.PREMIUM_SCREENING_PRICING_TYPE.REDUCED,
                    disabled:Boolean(this.isReducedPriceAvailable),
                    action:this.setPricingType,
                    icon: "mdi-theater",
                    price:'€22',
                    alert:{
                        message:"",
                        visible:this.isReducedPriceAvailable
                    },
                    features:[
                        {title:this.$t('screener.billing.pricing.reduced.feature_1',{
                            revenue_percentage:'15%'
                        })},
                        {title:this.$t('screener.billing.pricing.reduced.feature_2')},
                        {title:this.$t('screener.billing.pricing.reduced.feature_3')}
                    ]
                }
            ]
        }
    },
    methods:{
        setPricingType(pricingType){
            this.pricingType = pricingType;
            this.$emit("update:pricing_type",pricingType);
            this.$emit("goToStep", 2);
        },
        redirectTo(){
            this.$emit("redirectTo");
        }
    }
}
</script>

<style>

</style>
